export default __webpack_public_path__ + "static/media/island_4_with_objects.1b1dd486.png";